import React, { Component } from 'react'
import { connect } from 'react-redux'
import data, { key_local_storage_user } from '../../lib/backend/data'
import { Link } from 'react-router-dom'
import Moment from 'react-moment';
import 'moment/locale/es';
import { confirmAlert } from 'react-confirm-alert'; // Import
import Selector from 'react-select';
import { BsArrowRepeat, BsCircle, BsFillTrashFill, BsSendCheckFill, BsWhatsapp } from 'react-icons/bs'
import { AiFillCheckCircle, AiOutlineFileSearch, AiOutlineMail } from 'react-icons/ai'
import { BiSolidHelpCircle } from 'react-icons/bi'
import { MdOutlineCancel, MdPublic, MdSettingsInputAntenna } from 'react-icons/md'
import { FiPlus, FiSettings } from 'react-icons/fi'
import { Box, Button, ButtonGroup, Card, CircularProgress, FormControl, Grid, InputLabel, MenuItem, TextField, Select, Tooltip, Typography, CardContent, Divider } from '@mui/material'
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { cerrarSesion } from '../../redux/actions/session';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Structure from '../Structure';
import ModalEmpresas from '../Empresas/modal_seleccion';
import toast from 'react-hot-toast';
import SelectorGeneral from '../../subcomponents/general/selector_general';
import { IoMdArrowRoundBack } from "react-icons/io";
import { LoadingButton } from '@mui/lab';

const PantallaCargando = (props) => {

    return <div>
        <CircularProgress size={40} />
    </div>
}

class EstadosCarga extends Component {
    constructor(props) {
        super(props)
        this.state = {
            user: JSON.parse(localStorage.getItem(key_local_storage_user)),
            loadingEstados: true,
            loadingMore: false,
            total: 0,
            usuarios: [],
            parametro_busqueda: '',
            loadingBusqueda: false,
            filtro_rol: '',
            empresa: false,
            expanded: false,
            loadingSubestados: true,
            rutcliente: '',
            loadingUpload: false,
            clienteconsultar: { value: this.props.idconsulta, label: this.props.razonsocial },
            tipovisualizacion: 'estados',
            tab_notificaciones: "notificaciones",
            estados: [],
            subestados: [],
            nuevo_estado: {},
            nuevo_subestado: {},
            id_estado_crear_subestado: false,
            eliminando: false,
            loadingAcciones: true,
            acciones: [],
            acciones_subestado_actual: [],
            eliminandoAcciones: false,
            tipos_servicio: [],
            filtro_tipo_servicio: '',
            configuracion: {},
            loadingConfiguracionNotificaciones: true,
            loadingConfiguracion: true,
            plantillas_ws: [],
            loadingPlantillasWhatsapp: true
        }

        this.handleChange = this.handleChange.bind(this)
        this.buscarUsuario = this.buscarUsuario.bind(this)
        this.handlechangeStatus = this.handlechangeStatus.bind(this)
        this.handleChangeSelectTipoServicio = this.handleChangeSelectTipoServicio.bind(this)
        this.handleChangeSelectTipoServicioFiltro = this.handleChangeSelectTipoServicioFiltro.bind(this)
        this.handleChangeAccion = this.handleChangeAccion.bind(this)
        this.handleChangeAccionArray = this.handleChangeAccionArray.bind(this)
        this.handlechangeSubestado = this.handlechangeSubestado.bind(this)
        this.handleChangeConfig = this.handleChangeConfig.bind(this)
        this.handleChangeCondicion = this.handleChangeCondicion.bind(this)
        this.handleChangeTab = this.handleChangeTab.bind(this)

    }

    handleChange(e) {
        const { name, value } = e.target
        return this.setState({ [name]: value })
    }

    handleChangeAccion(e) {
        const { name, value, id } = e.target
        const { acciones_subestado_actual } = this.state
        const i = acciones_subestado_actual.findIndex(acc => acc._id === id)
        if (i < 0) return false
        acciones_subestado_actual[i][name] = value
        console.log(acciones_subestado_actual)
        return this.setState({ acciones_subestado_actual })
    }

    handleChangeCondicion(e) {
        const { name, value, id } = e.target
        const pos = e.target.getAttribute('pos')
        const { acciones_subestado_actual } = this.state
        const i = acciones_subestado_actual.findIndex(acc => acc._id === id)
        if (i < 0) return false
        acciones_subestado_actual[i].conditions[parseInt(pos)][name] = value
        console.log(acciones_subestado_actual)
        return this.setState({ acciones_subestado_actual })
    }

    eliminarCondicion(id, pos) {
        const { acciones_subestado_actual } = this.state
        const i = acciones_subestado_actual.findIndex(acc => acc._id === id)
        if (i < 0) return false
        acciones_subestado_actual[i].conditions.splice(pos, 1)
        return this.setState({ acciones_subestado_actual })
    }

    handleChangeAccionArray(e) {
        const { value, id } = e.target
        const { acciones_subestado_actual } = this.state
        const i = acciones_subestado_actual.findIndex(acc => acc._id === id)
        if (i < 0) return false
        acciones_subestado_actual[i].valor = value
        this.setState({ acciones_subestado_actual })
        const tienecoma = value.indexOf(',')
        if (tienecoma < 0) return false
        const dividir = value.split(',')

        if (!acciones_subestado_actual[i].opciones) acciones_subestado_actual[i].opciones = []
        acciones_subestado_actual[i].opciones.push(dividir[0])

        acciones_subestado_actual[i].valor = ''
        return this.setState({ acciones_subestado_actual })
    }

    componentDidMount() {
        this.getEstados()
        this.getConfiguracion('servicios', 'admin', 'tipos_servicio')
        this.getAcciones()
        this.getPlantillasWhatsapp()
    }

    getPlantillasWhatsapp() {
        const { user } = this.state
        const loading = 'loadingPlantillasWhatsapp'
        this.setState({ [loading]: true })
        return fetch(`${data.urlapi}/whatsapp/plantillas`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer: ${user.tokenSession}`
            }
        })
            .then(pros => pros.json())
            .then(data => {
                if (!data) {
                    toast.warn('No hay configuración de notificaciones creada para este subestado', this.state.toaststyle)
                } else if (data.errorMessage) {
                    toast.error(data.errorMessage)
                    return this.setState({ [loading]: false })
                } else if (Array.isArray(data) !== false) {
                    this.setState({ plantillas_ws: data })
                }
                return this.setState({ [loading]: false })
            })
            .catch(error => {
                toast.error('No pudimos cargar las plantillas de whatsapp', this.state.toaststyle)
                this.setState({ [loading]: false })
            })
    }

    async getConfiguracion(tipo, propietario, estado) {
        const { user } = this.state
        const loading = 'loadingConfiguracion'
        this.setState({ [loading]: true })
        return fetch(`${data.urlapi}/estadoscarga/list/select`, {
            method: "POST",
            body: JSON.stringify({
                condicion: { tipo, propietario }
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer: ${user.tokenSession}`
            }
        })
            .then(pros => pros.json())
            .then(data => {
                console.log(data)
                if (data.errorMessage) {
                    toast.error(data.errorMessage)
                    return this.setState({ loadingFormulario: false })
                } else if (Array.isArray(data) !== false) {
                    if (data.length > 0) {
                        const datos = data.map(e => ({ value: e._id, label: e.title }))
                        this.setState({ [estado]: datos })
                    }
                }
                return this.setState({ [loading]: false })
            })
            .catch(error => {
                toast.error('No pudimos cargar la información', this.state.toaststyle)
                this.setState({ [loading]: false })
            })
    }

    getEstados(propietario) {
        const { user } = this.state
        const loading = 'loadingEstados'
        this.setState({ [loading]: true })
        return fetch(`${data.urlapi}/estadoscarga/details`, {
            method: "POST",
            body: JSON.stringify({
                condicion:{
                    propietario: propietario ? propietario : "admin",
                    pais_code: this.props.pais_code
                }
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer: ${user.tokenSession}`
            },
        })
            .then(pros => pros.json())
            .then(data => {
                if(!data){

                } else if (data.errorMessage) {
                    toast.error(data.errorMessage)
                } else if(data.estados){
                    if(Array.isArray(data.estados) !== false ){
                        this.setState({ subestados: data.subestados, estados: data.estados })
                    }
                }
                this.setState({ [loading]: false })
            })
            .catch(error => {
                toast.error('No pudimos cargar la información', this.state.toaststyle)
                this.setState({ [loading]: false })
            })
    }

    buscar() {
        const { parametro_busqueda, user } = this.state
        if (!parametro_busqueda) return toast.error('El valor de búsqueda es requerido')
        if (parametro_busqueda.length < 3) return toast.error('Ingresa un valor de búsqueda válido')
        let loading = 'loadingBusqueda'
        this.setState({ [loading]: true })
        return fetch(`${data.urlapi}/usuarios/search`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer: ${user.tokenSession}`
            },
            body: JSON.stringify({ parametro_busqueda })
        })
            .then(res => {
                if (res.status === 401) return this.props.cerrarSesion()
                return res.json()
            })
            .then(res => {
                if (!res) {
                    toast.error('Sin datos')
                    return this.setState({ [loading]: false })
                } else if (res.errorMessage) {
                    toast.error(res.errorMessage)
                    return this.setState({ [loading]: false })
                }
                if (res.length < 1) {
                    toast.warn('No se encontraron resultados')
                    return this.setState({ [loading]: false })
                }
                return this.setState({ usuarios: res, filtro_rol: '', [loading]: false })
            })
            .catch(error => {
                this.setState({ [loading]: false })
                toast.error("Error al consultar la información, intente nuevamente", this.state.toaststyle)
            })
    }

    async getUsuarios(cargarmas) {
        const { user, usuarios } = this.state
        let loading = 'loadingEstados'
        if (cargarmas === true) loading = 'loadingMore'
        this.setState({ [loading]: true })
        return fetch(`${data.urlapi}/usuarios/list?skip=${usuarios.length}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer: ${user.tokenSession}`
            }
        })
            .then(res => {
                if (res.status === 401) return this.props.cerrarSesion()
                return res.json()
            })
            .then(res => {
                if (!res) {
                    toast.error('Sin datos')
                    return this.setState({ [loading]: false })
                } else if (res.errorMessage) {
                    toast.error(res.errorMessage)
                    return this.setState({ [loading]: false })
                }
                if (cargarmas === true) {
                    if (Array.isArray(res.datos) !== false) {
                        const final_array = usuarios.concat(res.datos)
                        return this.setState({ usuarios: final_array, total: res.total, [loading]: false })
                    } else {
                        return this.setState({ [loading]: false })
                    }
                } else {
                    this.setState({ usuarios: res.datos, total: res.total, [loading]: false })
                }
            })
            .catch(error => {
                this.setState({ [loading]: false })
                toast.error("Error al consultar la información, intente nuevamente", this.state.toaststyle)
            })
    }

    buscarUsuario(e) {
        e.preventDefault()
        return this.buscar()
    }

    sinRegistros() {
        return <div className='p-5'>
            <Grid container spacing={2} className="justify-content-md-center">
                <Grid item md={6} className="text-center">
                    <Typography variant="h4">Aún no tienes usuarios</Typography>
                    <p>Puedes crear diversos usuarios y asignar permisos a cada uno de ellos</p>
                </Grid> 
            </Grid>
        </div>
    }

    crearEstado() {
        const { nuevo_estado, empresa, user, estados } = this.state
        if (!nuevo_estado.titulo) return toast.error('Título es requerido', this.state.toaststyle)
        if (!nuevo_estado.color) return toast.error('color es requerido', this.state.toaststyle)
        if (!nuevo_estado.codigo_estado) return toast.error('Código es requerido', this.state.toaststyle)
        if (!nuevo_estado.tipos_servicio) return toast.error('tipo servicio es requerido', this.state.toaststyle)
        if (nuevo_estado.tipos_servicio.length < 1) return toast.error('tipo servicio es requerido', this.state.toaststyle)
        if (nuevo_estado.tipo.length < 1) return toast.error('tipo es requerido', this.state.toaststyle)
        nuevo_estado.propietario = empresa ? empresa.rut : "admin"
        this.setState({ loadingFormulario: true })
        return fetch(`${data.urlapi}/estadoscarga/create-or-edit-estado`, {
            method: 'POST',
            body: JSON.stringify(nuevo_estado),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer: ${user.tokenSession}`
            }
        })
            .then(pros => pros.json())
            .then(async pros => {
                if (!pros) {
                    toast.error('Hubo un error de servidor', this.state.toaststyle)
                    return this.setState({ loadingFormulario: false })
                } else if (pros.errorMessage) {
                    toast.error(pros.errorMessage, this.state.toaststyle)
                    return this.setState({ loadingFormulario: false })
                }
                toast.success(`Realizado exitosamente`, this.state.toaststyle)
                if (!nuevo_estado._id) {
                    if (pros._id) estados.push(pros)
                }
                return this.setState({ loadingFormulario: false, estados, tipovisualizacion: 'estados' })
            })
            .catch(async error => {
                console.log(error)
                this.setState({ loadingFormulario: false })
                return toast.error("No pudimos consultar la información, intente de nuevo recargando la página", this.state.toaststyle)
            })
    }

    handlechangeStatus(e) {
        const { name, value } = e.target
        const { nuevo_estado } = this.state
        nuevo_estado[name] = value
        return this.setState({ nuevo_estado })
    }

    handleChangeSelectTipoServicioFiltro(e) {
        return this.setState({ filtro_tipo_servicio: e.value })
    }

    handleChangeSelectTipoServicio(e) {
        const { nuevo_estado } = this.state
        let opciones = []
        if (e) {
            e.map(valor => {
                return opciones.push(valor.value)
            })
        }
        nuevo_estado.tipos_servicio = opciones
        return this.setState({ nuevo_estado })
    }

    formularioCreacion() {
        const { loadingFormulario, loadingConfiguracion, nuevo_estado, tipos_servicio } = this.state

        if (!nuevo_estado) return false
        if (loadingFormulario) return <PantallaCargando />

        let opciones_tipo_servicio_elegidas = []

        if (nuevo_estado.tipos_servicio) {
            if (Array.isArray(nuevo_estado.tipos_servicio) !== false) {
                if (nuevo_estado.tipos_servicio.length > 0) {
                    opciones_tipo_servicio_elegidas = tipos_servicio.filter(op => {
                        return nuevo_estado.tipos_servicio.includes(op.value)
                    })
                }
            }
        }

        return <div >

            <Typography variant='h5'>{nuevo_estado._id ? `Editar ${nuevo_estado.titulo}` : `Crear nuevo estado`}</Typography>
            <Button onClick={() => this.setState({ tipovisualizacion: 'estados' })} startIcon={<IoMdArrowRoundBack />} >ATRÁS</Button>
            <Grid container spacing={2}>
                <Grid item md={3} xs={12}>
                <FormControl fullWidth className='mb-3'>
                <TextField
                    fullWidth
                    label="Título"
                    name="titulo" 
                    variant='filled'
                    required={true}
                    defaultValue={nuevo_estado.titulo} 
                    onChange={this.handlechangeStatus}
                />
                </FormControl>
                </Grid>
                
                <Grid item md={3} xs={12}>
                <FormControl fullWidth className='mb-3'>
                <TextField
                    fullWidth
                    label="Código"
                    name="codigo_estado" 
                    variant='filled'
                    required={true}
                    defaultValue={nuevo_estado.codigo_estado} 
                    onChange={this.handlechangeStatus}
                />
                </FormControl>
                </Grid>
                
                <Grid item md={3} xs={12}>
                <FormControl fullWidth className='mb-3'>
                <TextField
                    label="Color"
                    fullWidth
                    name="Color" 
                    variant='filled'
                    type="color"
                    required={true}
                    defaultValue={nuevo_estado.Color} 
                    onChange={this.handlechangeStatus}
                />
                </FormControl>
                </Grid>

                <Grid item md={3} xs={12}>
                <FormControl fullWidth className='mb-3'>
                    <InputLabel id='demo-simple-select-label'>Tipo</InputLabel>
                    <Select
                    labelId='demo-simple-select-label'
                    id='demo-simple-select'
                    label='Estado'
                    name='tipo'
                    defaultValue={nuevo_estado.tipo}
                    onChange={this.handlechangeStatus}>
                    <MenuItem value=''>Seleccione</MenuItem>
                    <MenuItem value='web'>Web</MenuItem>
                    <MenuItem value='movil'>Móvil</MenuItem>
                    </Select>
                </FormControl>
                </Grid>

                <Grid item md={6} className="mb-3">
                    <Typography variant="h6" className='hover' onClick={() => this.setBoleanPropertyEstado('mostrar_linea_tiempo')}>{nuevo_estado.mostrar_linea_tiempo === true ?
                        <i className="fas text-success fa-check-square"></i> :
                        <i className="far fa-square"></i>} Mostrar en la línea de tiempo de tracking</Typography>
                </Grid> 
                <Grid item md={6} className="mb-3">
                    <Typography variant="h6" className='hover' onClick={() => this.setBoleanPropertyEstado('opcional_linea_tiempo')}>{nuevo_estado.opcional_linea_tiempo === true ?
                        <i className="fas text-success fa-check-square"></i> :
                        <i className="far fa-square"></i>} Opcional en la linea de tiempo</Typography>
                </Grid> 

                {
                    nuevo_estado.mostrar_linea_tiempo === true ? <Grid item md={3} className="mb-3">
                        <label className=''>Posición en la línea de tiempo</label>
                        <input  name="posicion_linea_tiempo" defaultValue={nuevo_estado.posicion_linea_tiempo} onChange={this.handlechangeStatus} />
                    </Grid>  : false
                }
                <Grid item md={6} className="mb-3">
                    <label className=" ">Filtrar por tipo servicio</label>
                    <Selector
                        style={{ marginBottom: 10 }}
                        onChange={this.handleChangeSelectTipoServicio}
                        defaultValue={opciones_tipo_servicio_elegidas}
                        options={tipos_servicio}
                        isMulti={true}
                        isLoading={loadingConfiguracion}
                        noOptionsMessage={() => 'Sin opciones'}
                        placeholder="Tipo de servicio..."
                    />
                </Grid> 

                <Grid item xs={12} className="mb-3">
                    <Button variant="contained" onClick={() => this.crearEstado()}>{nuevo_estado._id ? 'GUARDAR CAMBIOS' : 'CREAR'}</Button>
                </Grid> 
            </Grid>
        </div>
    }

    editarEstado(nuevo_estado) {
        return this.setState({ tipovisualizacion: 'nuevoestado', nuevo_estado })
    }

    eliminarRegistro(id) {
        const { estados, user } = this.state
        const estado_loading = 'eliminando'
        this.setState({ [estado_loading]: true })
        return fetch(`${data.urlapi}/estadoscarga/eliminar-estado?id=${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer: ${user.tokenSession}`
            },
        })
            .then(res => res.json())
            .then(res => {
                if (res.errorMessage) {
                    toast.error(res.errorMessage)
                    return this.setState({ [estado_loading]: false })
                }
                toast.success('Eliminado exitosamente', this.state.toaststyle)
                const i = estados.findIndex(a => a._id === id)
                if (i > -1) estados.splice(i, 1)
                return this.setState({ [estado_loading]: false, estados })
            })
            .catch(error => {
                toast.error("Ocurrió un error de servidor", this.state.toaststyle)
                return this.setState({ [estado_loading]: false })
            })
    }

    solicitarEliminarAccion(id) {
        return confirmAlert({
            title: '¿Estás seguro?',
            message: `¿Deseas eliminar este item? Esta opción no se puede deshacer`,
            buttons: [
                {
                    label: 'CONFIRMAR',
                    onClick: () => this.eliminarAccion(id)
                },
                {
                    label: 'CANCELAR',
                    onClick: () => false
                },
            ],
        })
    }

    solicitarEliminar(id) {
        return confirmAlert({
            title: '¿Estás seguro?',
            message: `¿Deseas eliminar este item? Esta opción no se puede deshacer`,
            buttons: [
                {
                    label: 'CONFIRMAR',
                    onClick: () => this.eliminarRegistro(id)
                },
                {
                    label: 'CANCELAR',
                    onClick: () => false
                },
            ],
        })
    }

    eliminarAccion(id) {
        const { acciones_subestado_actual } = this.state
        const estado_loading = 'eliminandoAcciones'
        this.setState({ [estado_loading]: true })
        return fetch(`${data.urlapi}/estadoscarga/eliminar-accion?id=${id}`)
            .then(res => res.json())
            .then(res => {
                if (res.errorMessage) {
                    toast.error(res.errorMessage)
                    return this.setState({ [estado_loading]: false })
                }
                toast.success('Eliminado exitosamente', this.state.toaststyle)
                const i = acciones_subestado_actual.findIndex(a => a._id === id)
                if (i > -1) acciones_subestado_actual.splice(i, 1)
                return this.setState({ [estado_loading]: false, acciones_subestado_actual })
            })
            .catch(error => {
                toast.error("Ocurrió un error de servidor", this.state.toaststyle)
                return this.setState({ [estado_loading]: false })
            })
    }

    mostrarTiposServicioConcatenados(tipos) {
        const { tipos_servicio } = this.state
        if (!tipos) return false
        if (Array.isArray(tipos) !== true) return false
        if (tipos.length < 1) return false
        return tipos.map(tipo => <span className='spanguia mr-2' style={{ fontSize: 11 }}>{tipo}</span>)
    }

    nuevoSubEstado(id_estado_crear_subestado) {
        this.getConfiguracionNotificaciones(false)
        return this.setState({ tipovisualizacion: 'nuevosubestado', id_estado_crear_subestado, nuevo_subestado: {} })
    }

    async getConfiguracionNotificaciones(idsubestado) {
        const { user } = this.state
        const loading = 'loadingConfiguracionNotificaciones'
        if (!idsubestado) return this.setState({ [loading]: false })
        this.setState({ [loading]: true })
        return fetch(`${data.urlapi}/estadoscarga/notificacion-por-subestado?idsubestado=${idsubestado}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer: ${user.tokenSession}`
            },
        })
            .then(pros => pros.json())
            .then(data => {
                if (!data) {
                    toast.warn('No hay configuración de notificaciones creada para este subestado', this.state.toaststyle)
                } else if (data.errorMessage) {
                    toast.error(data.errorMessage)
                }
                return this.setState({ [loading]: false, configuracion: data ? data : {} })
            })
            .catch(error => {
                toast.error('No pudimos cargar la información', this.state.toaststyle)
                this.setState({ [loading]: false })
            })
    }

    editarSubEstado(nuevo_subestado) {
        this.setState({
            tipovisualizacion: 'nuevosubestado',
            nuevo_subestado,
            id_estado_crear_subestado: nuevo_subestado.idparent,
            acciones_subestado_actual: []
        })
        this.getConfiguracionNotificaciones(nuevo_subestado._id)
        return this.getAccionesPorSubEstado(nuevo_subestado._id)
    }

    getAccionesPorSubEstado(idsubestado) {
        const { user } = this.state
        const loading = 'loadingAcciones'
        this.setState({ [loading]: true })
        return fetch(`${data.urlapi}/estadoscarga/acciones-por-subestado?idsubestado=${idsubestado}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer: ${user.tokenSession}`
            },
        })
            .then(pros => pros.json())
            .then(data => {
                console.log(data)
                if (data.errorMessage) {
                    toast.error(data.errorMessage)
                    return this.setState({ [loading]: false })
                }
                this.setState({ [loading]: false, acciones_subestado_actual: data })
            })
            .catch(error => {
                toast.error('No pudimos cargar la información', this.state.toaststyle)
                this.setState({ [loading]: false })
            })
    }

    getAcciones() {
        const { user } = this.state
        const loading = 'loadingAcciones'
        this.setState({ [loading]: true })
        return fetch(`${data.urlapi}/estadoscarga/acciones`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer: ${user.tokenSession}`
            },
        })
            .then(pros => pros.json())
            .then(data => {
                if (data.errorMessage) {
                    toast.error(data.errorMessage)
                    return this.setState({ [loading]: false })
                }
                if (data.length < 1) toast.warn('No hay acciones disponibles para crear formularios', this.state.toaststyle)
                this.setState({ [loading]: false, acciones: data })
            })
            .catch(error => {
                toast.error('No pudimos cargar la información', this.state.toaststyle)
                this.setState({ [loading]: false })
            })
    }

    guardarCambiosAccion(id) {
        const { acciones_subestado_actual, user } = this.state
        const i = acciones_subestado_actual.findIndex(acc => acc._id === id)
        if (i < 0) return false
        const loading = 'loadingAcciones'
        acciones_subestado_actual[i].valor = ''
        this.setState({ [loading]: true })
        return fetch(`${data.urlapi}/estadoscarga/actualizar-accion`, {
            method: 'POST',
            body: JSON.stringify(acciones_subestado_actual[i]),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer: ${user.tokenSession}`
            }
        })
            .then(pros => pros.json())
            .then(async pros => {
                if (!pros) {
                    toast.error('Hubo un error de servidor', this.state.toaststyle)
                    return this.setState({ [loading]: false })
                } else if (pros.errorMessage) {
                    toast.error(pros.errorMessage, this.state.toaststyle)
                    return this.setState({ [loading]: false })
                }
                toast.success(`Operación realizada exitosamente`, this.state.toaststyle)
                return this.setState({ [loading]: false })
            })
            .catch(async error => {
                console.log(error)
                this.setState({ [loading]: false })
                return toast.error("No pudimos consultar la información, intente de nuevo recargando la página", this.state.toaststyle)
            })
    }

    obligatorio(id) {
        const { acciones_subestado_actual } = this.state
        const i = acciones_subestado_actual.findIndex(acc => acc._id === id)
        if (i < 0) return false
        acciones_subestado_actual[i].required = acciones_subestado_actual[i].required === true ? false : true
        return this.setState({ acciones_subestado_actual })
    }

    removerOpcionAccion(_id, i) {
        const { acciones_subestado_actual } = this.state
        const pos = acciones_subestado_actual.findIndex(acc => acc._id === _id)
        if (pos < 0) return false
        acciones_subestado_actual[pos].opciones.splice(i, 1)
        return this.setState({ acciones_subestado_actual })
    }

    mostrarAccionesDisponibles(nuevo_subestado) {
        if (!nuevo_subestado._id) return false
        const { acciones, loadingAcciones } = this.state
        if (loadingAcciones) return <CircularProgress />
        if (acciones.length < 1) return <Typography variant="h4">No hay acciones disponibles para agregar al formulario</Typography>

        return <div>
            <p className='mb-2'>Toca la opción para agregar a este subestado</p>
            {
                acciones.map((accion, i) => {
                    return <Button variant='outlined' key={`accion-${i}`} onClick={() => this.crearAccion(accion.tipo_accion, nuevo_subestado._id)} className='p-2 hover' style={{ backgroundColor: 'white', border: '1px solid #767676', marginRight: 10 }} >{accion.titulo}</Button>
                })
            }
        </div>
    }

    eliminarSubEstado(id) {
        const { subestados } = this.state
        const estado_loading = 'eliminando'
        this.setState({ [estado_loading]: true })
        return fetch(`${data.urlapi}/estadoscarga/eliminar-subestado?id=${id}`)
            .then(res => res.json())
            .then(res => {
                if (res.errorMessage) {
                    toast.error(res.errorMessage)
                    return this.setState({ [estado_loading]: false })
                }
                toast.success('Eliminado exitosamente', this.state.toaststyle)
                const i = subestados.findIndex(a => a._id === id)
                if (i > -1) subestados.splice(i, 1)
                return this.setState({ [estado_loading]: false, subestados })
            })
            .catch(error => {
                toast.error("Ocurrió un error de servidor", this.state.toaststyle)
                return this.setState({ [estado_loading]: false })
            })
    }

    solicitarEliminarSubEstado(id) {
        return confirmAlert({
            title: '¿Estás seguro?',
            message: `¿Deseas eliminar este item? Esta opción no se puede deshacer`,
            buttons: [
                {
                    label: 'CONFIRMAR',
                    onClick: () => this.eliminarSubEstado(id)
                },
                {
                    label: 'CANCELAR',
                    onClick: () => false
                },
            ],
        })
    }

    crearSubEstado() {
        const { nuevo_subestado, subestados, user, clienteconsultar, id_estado_crear_subestado } = this.state
        if (!nuevo_subestado.titulo) return toast.error('Título es requerido', this.state.toaststyle)
        if (!nuevo_subestado.codigo_estado) return toast.error('Código es requerido', this.state.toaststyle)
        if (!nuevo_subestado.tipo) return toast.error('tipo es requerido', this.state.toaststyle)
        nuevo_subestado.propietario = clienteconsultar.value
        nuevo_subestado.idparent = id_estado_crear_subestado
        this.setState({ loadingFormulario: true })
        return fetch(`${data.urlapi}/estadoscarga/create-or-edit-subestado`, {
            method: 'POST',
            body: JSON.stringify(nuevo_subestado),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer: ${user.tokenSession}`
            }
        })
            .then(pros => pros.json())
            .then(async pros => {
                console.log(pros)
                if (!pros) {
                    toast.error('Hubo un error de servidor', this.state.toaststyle)
                    return this.setState({ loadingFormulario: false })
                } else if (pros.errorMessage) {
                    toast.error(pros.errorMessage, this.state.toaststyle)
                    return this.setState({ loadingFormulario: false })
                }
                toast.success(`Operación realizada exitosamente`, this.state.toaststyle)
                if (!nuevo_subestado._id) {
                    if (pros._id) subestados.push(pros)
                }
                return this.setState({ loadingFormulario: false, subestados, tipovisualizacion: 'estados' })
            })
            .catch(async error => {
                this.setState({ loadingFormulario: false })
                return toast.error("No pudimos consultar la información, intente de nuevo recargando la página", this.state.toaststyle)
            })
    }

    setBoleanPropertyEstado(name) {
        const { nuevo_estado } = this.state
        nuevo_estado[name] = nuevo_estado[name] === true ? false : true
        return this.setState({ nuevo_estado })
    }

    setBoleanProperty(name) {
        const { nuevo_subestado } = this.state
        nuevo_subestado[name] = nuevo_subestado[name] === true ? false : true
        return this.setState({ nuevo_subestado })
    }

    handlechangeSubestado(e) {
        const { name, value } = e.target
        const { nuevo_subestado } = this.state
        nuevo_subestado[name] = value
        console.log(nuevo_subestado)
        return this.setState({ nuevo_subestado })
    }

    agregarCondicion(id) {
        const { acciones_subestado_actual } = this.state

        const i = acciones_subestado_actual.findIndex(e => e._id === id)

        if (i < 0) return false

        if (!acciones_subestado_actual[i].conditions) acciones_subestado_actual[i].conditions = []

        acciones_subestado_actual[i].conditions.push({
            accion: '',
            operador: '',
            campo: ''
        })

        return this.setState({ acciones_subestado_actual })
    }

    handleChangeTab(event, tab_notificaciones) {
        return this.setState({ tab_notificaciones })
    }

    formularioCreacionSubestado() {
        const { loadingFormulario, tab_notificaciones, loadingAcciones, eliminandoAcciones, acciones_subestado_actual, estados, nuevo_subestado, id_estado_crear_subestado } = this.state

        let titulo_estado = ''
        const iestado = estados.findIndex(es => es._id === id_estado_crear_subestado)
        if (iestado > -1) titulo_estado = estados[iestado].titulo

        const estilo_icono = {
            backgroundColor: "white",
            padding: 15,
            borderRadius: "50%",
            boxShadow: "0px 0px 17px -10px black",
            marginBottom: 10
        }

        const estilo_icono_check = {
            // display: "block",
            // margin: "0 auto",
            // marginTop: -21,
            // marginLeft: 61
        }

        const estilo_texto = {
            fontWeight: "bold",
            fontSize: 11,
            display: "inline",
            backgroundColor: "white",
            borderRadius: 5,
            padding: "5px 15px"
        }

        const propiedades_estado = [
            {
                slug: "notificaciones",
                titulo: "Notificaciones",
                items: [
                    {
                        slug: "email",
                        titulo: "Envía correo electrónico",
                        help_text: "",
                        icon: <AiOutlineMail size={50} style={estilo_icono} />
                    },
                    {
                        slug: "whatsapp",
                        titulo: "Envía whatsapp",
                        help_text: "",
                        icon: <BsWhatsapp size={50} style={estilo_icono} />
                    }
                ]
            },
            {
                slug: "trazabilidad",
                titulo: "Trazabilidad",
                items: [
                    {
                        slug: "allor_repeat",
                        titulo: "Es un punto de control",
                        help_text: "Esto permite repetir el estado múltiples veces y no cambia el estado actual del pedido",
                        icon: <BsArrowRepeat size={50} style={estilo_icono} />
                    },
                    {
                        slug: "enable_tracking_analyse",
                        titulo: "Activa el rastreo",
                        help_text: "Cargas B2B e Internacionales, inicia el análisis de ruta para el informe final",
                        icon: <MdSettingsInputAntenna size={50} style={estilo_icono} />
                    }
                ]
            },
            {
                slug: "control",
                titulo: "Control",
                items: [
                    {
                        slug: "publico",
                        titulo: "Público ",
                        help_text: "Clientes ven este estado en el tracking",
                        icon: <MdPublic size={50} style={estilo_icono} />
                    },
                    {
                        slug: "annulment",
                        titulo: "Estado de anulación",
                        help_text: "",
                        icon: <MdOutlineCancel size={50} style={estilo_icono} />
                    },
                    {
                        slug: "notificar_planel_flota",
                        titulo: "Requiere auditarse por Flota",
                        help_text: "Estos estados llegarán a una pantalla especial para una revisión manual",
                        icon: <AiOutlineFileSearch size={50} style={estilo_icono} />
                    },
                    {
                        slug: "finalizar",
                        titulo: "Estado final ",
                        help_text: "Considerado como finalizado el servicio, necesario para las métricas y los informes de trazabilidad",
                        icon: <BsSendCheckFill size={50} style={estilo_icono} />
                    },
                ]
            },

        ]

        if (loadingFormulario) return <CircularProgress />

        return <div >
            <Typography variant="h6"> {nuevo_subestado._id ? `Editar subestado ${nuevo_subestado.titulo} · ${titulo_estado}` : `Crear nuevo subestado dentro de ${titulo_estado}`} </Typography>
            <Button startIcon={<IoMdArrowRoundBack />} onClick={() => this.setState({ tipovisualizacion: 'estados', nuevo_subestado: {}, acciones_subestado_actual: [] })}>ATRÁS</Button>
            <Grid container  spacing={2}>
                <Grid item md={3} xs={12}>
                <FormControl fullWidth className='mb-3'>
                <TextField
                    label="Título"
                    fullWidth
                    name="titulo" 
                    defaultValue={nuevo_subestado.titulo} 
                    onChange={this.handlechangeSubestado}
                    variant='filled'
                    required={true}
                />
                </FormControl>
                </Grid>

                <Grid item md={3} xs={12}>
                <FormControl fullWidth className='mb-3'>
                <TextField
                    label="Código"
                    fullWidth
                    name="codigo_estado" 
                    defaultValue={nuevo_subestado.codigo_estado} 
                    onChange={this.handlechangeSubestado}
                    variant='filled'
                    required={true}
                />
                </FormControl>
                </Grid>

                <Grid item md={3} xs={12}>
                <FormControl fullWidth className='mb-3'>
                    <InputLabel id='demo-simple-select-label'>Tipo</InputLabel>
                    <Select
                    labelId='demo-simple-select-label'
                    id='demo-simple-select'
                    label='Estado'
                    name='tipo'
                    defaultValue={nuevo_subestado.tipo}
                    onChange={this.handlechangeSubestado}>
                    <MenuItem value=''>Seleccione</MenuItem>
                    <MenuItem value='web'>Web</MenuItem>
                    <MenuItem value='movil'>Móvil</MenuItem>
                    </Select>
                </FormControl>
                </Grid>

                <Grid item md={3} xs={12}>
                <FormControl fullWidth className='mb-3'>
                <TextField
                    fullWidth
                    label="Color"
                    name="color" 
                    type="color"
                    defaultValue={nuevo_subestado.color} 
                    onChange={this.handlechangeSubestado}
                    variant='filled'
                    required={true}
                />
                </FormControl>
                </Grid>
                

                <Grid item md={12} xs={12}>
                    <Card className='mb-2' style={{ padding: "10px 28px" }}>
                        <h3 className='mb-0'><FiSettings /> Configuración</h3>
                        <p>Selecciona las opciones a continuación para activarlas</p>
                        <Box sx={{ width: '100%', typography: 'body1' }}>
                        <TabContext value={tab_notificaciones}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={this.handleChangeTab} aria-label="lab API tabs example">
                                {
                                    propiedades_estado.map(prop => {
                                        return <Tab label={prop.titulo} value={prop.slug} />
                                    })
                                }
                            </TabList>
                            </Box>
                            {
                                propiedades_estado.map(prop => {



                                    return <TabPanel value={prop.slug} className='pt-4'>
                                        <Grid container spacing={2}>
                                            {
                                                prop.items.map((item, i) => {

                                                    const activo = nuevo_subestado[item.slug] === true
                                                    const overlay_item = <Tooltip id={item.hlp_text} title={item.help_text} >
                                                            <BiSolidHelpCircle size={13} color='#a7a7a7' />
                                                        </Tooltip>

                                                    return <Grid item md={3} key={`est-${i}-${prop.slug}`} className='hover p-3'>
                                                        <div style={{ textAlign: "center" }} onClick={() => this.setBoleanProperty(item.slug)}>
                                                            {item.icon}
                                                            <div></div>
                                                            <Typography variant='h5' style={{ fontSize: 13 }}>{item.titulo} {item.help_text ? overlay_item : false}</Typography>
                                                            {activo ? <Typography style={estilo_texto}><AiFillCheckCircle color='#60cb4a' style={estilo_icono_check} /> ACTIVO</Typography> : <Typography style={estilo_texto}><AiFillCheckCircle color='#cbcbcb' style={estilo_icono_check} /> INACTIVO</Typography>}
                                                        </div>
                                                    </Grid> 
                                                })
                                            }
                                        </Grid>
                                    </TabPanel>
                                })
                            }
                        </TabContext>
                        </Box>
                    </Card>

                </Grid>
                <Grid item md={12} xs={12}>
                <LoadingButton variant="contained" loading={loadingFormulario} onClick={() => this.crearSubEstado()}>{nuevo_subestado._id ? 'GUARDAR CAMBIOS' : 'CREAR'}</LoadingButton>
                </Grid>

                <Grid item md={12} xs={12}>
                    <Typography variant='h5'><i className="fas fa-file-alt"></i> Compromiso</Typography>
                    <Typography>Puedes modificar automáticamente las fechas de compromiso de una orden al recibir este estado</Typography>

                    <Typography >Agregar días a la fecha de compromiso</Typography>
                    <TextField style={{ width: "100%" }}  type="number" name="sumar_dias" defaultValue={nuevo_subestado.sumar_dias} onChange={this.handlechangeSubestado} />
                    <Divider />

                </Grid>

                <Grid item md={12} xs={12}>
                    <Typography variant='h5'><i className="fas fa-file-alt"></i> Formulario App Móvil</Typography>
                    <Divider />
                    {this.mostrarAccionesDisponibles(nuevo_subestado)}
                    {acciones_subestado_actual.length > 0 ? <div>
                        <Divider />
                        {
                            acciones_subestado_actual.map((accion, i) => {
                                return <Card sx={{ mb:2 }}>
                                    <CardContent>
                                        <span>{accion.tipo_accion}</span>
                                        <Typography variant='h5'>Título</Typography>
                                        <TextField style={{ width: "100%" }} name="titulo" defaultValue={accion.titulo} id={accion._id} onChange={this.handleChangeAccion} />
                                        {accion.tipo_accion === 'selector' ? <div>
                                            <Typography variant='h5'>Opciones (Separa cada valor con coma)</Typography>
                                            <TextField style={{ width: "100%" }} name="valor" placeholder='Escribe tu opción y a continuación escribe ,' value={accion.valor} id={accion._id} onChange={this.handleChangeAccionArray} />
                                            <Divider sx={{ mt:1, mb:2}} />
                                            {
                                                accion.opciones.map((opcion, i) => {
                                                    return <Box key={`opcion-${i}`} sx={{ p:2, mr:2, mb:2 }} style={{ color: "white", display: 'inline-block', borderRadius: 6, backgroundColor: '#535353' }}>
                                                        <Typography variant='h5'>{opcion} <Button  onClick={() => this.removerOpcionAccion(accion._id, i)}>REMOVER</Button></Typography>
                                                    </Box>
                                                })
                                            }
                                            <div className='mb-3'></div>
                                        </div> : false}

                                        <Typography variant='h6' onClick={() => this.obligatorio(accion._id)}>{accion.required === true ?
                                            <i className="fas text-success fa-check-square"></i> :
                                            <i className="far fa-square"></i>} Obligatorio</Typography>

                                        {
                                            accion.conditions ? accion.conditions.map((con, pos) => {
                                                return <div key={`condicion-${pos}`}>
                                                    <Card className='p-2 mb-2'>
                                                        <Grid container spacing={2}>
                                                            <Grid item md={1}>
                                                                <label className=' '>Borrar</label>
                                                                <Button size='sm' variant='danger' onClick={() => this.eliminarCondicion(accion._id, pos)} ><BsFillTrashFill /> </Button>
                                                            </Grid> 
                                                            <Grid item md={2}>
                                                                <label className=' '>Accion</label>
                                                                <select  name="action" value={con.action} id={accion._id} pos={pos} onChange={this.handleChangeCondicion} >
                                                                    <option value="">Acción </option>
                                                                    <option value="mostrar">Mostrar</option>
                                                                    <option value="ocultar">Ocultar</option>
                                                                </select>
                                                            </Grid> 
                                                            <Grid item md={3}>
                                                                <label className=' '>Campo</label>
                                                                <select  name="field" value={con.field} id={accion._id} pos={pos} onChange={this.handleChangeCondicion} >
                                                                    <option value="">Selecciona un campo </option>
                                                                    {
                                                                        acciones_subestado_actual.filter(ac => ac._id !== accion._id).map((option, iop) => {
                                                                            return <option key={`id${accion._id}-${iop}`} value={option._id}>{option.titulo ? option.titulo : "Sin título aún"}</option>
                                                                        })
                                                                    }
                                                                </select>
                                                            </Grid> 
                                                            <Grid item md={3}>
                                                                <label className=' '>Operador de comparación</label>
                                                                <select  name="operator" value={con.operator} id={accion._id} pos={pos} onChange={this.handleChangeCondicion} >
                                                                    <option value="">Selecciona un operador </option>
                                                                    <option value="=">Igual a {"(=)"}</option>
                                                                    <option value="!=">No igual a {"(!=)"}</option>
                                                                    <option value=">">Mayor que {"(>)"}</option>
                                                                    <option value="<">Menor que {"(<)"}</option>
                                                                    <option value=">=">Mayor o igual que {"(>=)"}</option>
                                                                    <option value="<=">Menor o igual que {"(<=)"}</option>
                                                                </select>
                                                            </Grid> 
                                                            <Grid item md={3}>
                                                                <label className=' '>Valor</label>
                                                                <input  name="value" value={con.value} id={accion._id} pos={pos} onChange={this.handleChangeCondicion} /></Grid> 
                                                        </Grid>
                                                    </Card>
                                                </div>
                                            }) : false
                                        }

                                        {/* <div className='mb-3'><Button size="sm" variant="light" onClick={() => this.agregarCondicion(accion._id)} >AGREGAR CONDICION</Button></div> */}

                                        <ButtonGroup>
                                            <Button disabled={loadingAcciones} className='btn btn-sm btn-success' onClick={() => this.guardarCambiosAccion(accion._id)}>{loadingAcciones ? "ESPERE UN MOMENTO..." : "GUARDAR"}</Button>
                                            <Button disabled={eliminandoAcciones} className='btn btn-sm btn-outline-danger' onClick={() => this.solicitarEliminarAccion(accion._id)}>{!eliminandoAcciones ? "ELIMINAR" : "ESPERE UN MOMENTO"}</Button>
                                        </ButtonGroup>
                                    </CardContent>
                                </Card>
                            })
                        }
                    </div> : <p className='mt-3'>No hay acciones para este sub estado</p>}
                </Grid>
                {this.mostrarNotificacionesConfig()}

            </Grid>
        </div>
    }

    setVar(status, texto) {
        const { configuracion } = this.state
        const valora_actual = configuracion[status] ? `${configuracion[status]} ` : ''
        configuracion[status] = `${valora_actual}${texto}`
        this.setState({ configuracion })
    }

    opciones_plantillas(status) {
        return <div>
            <p>Click para agregar una etiqueta de contenido dinámico</p>
            <Button size="sm" variant="outline-light" className='mr-3' onClick={() => this.setVar(status, '{{nombre_cliente}}')} >{'nombre_cliente'}</Button>
            <Button size="sm" variant="outline-light" className='mr-3' onClick={() => this.setVar(status, '{{nombre_direccion}}')} >{'nombre_direccion'}</Button>
            <Button size="sm" variant="outline-light" className='mr-3' onClick={() => this.setVar(status, '{{referencia}}')} >{'referencia'}</Button>
            <Button size="sm" variant="outline-light" className='mr-3' onClick={() => this.setVar(status, '{{ot}}')} >{'ot'}</Button>
            <Button size="sm" variant="outline-light" className='mr-3' onClick={() => this.setVar(status, '{{notas}}')} >{'notas'}</Button>
        </div>
    }

    handleChangeConfig(e) {
        const { configuracion } = this.state
        const { name, value } = e.target
        configuracion[name] = value
        return this.setState({ configuracion })
    }

    async guardarCambiosConfiguracion() {
        const { configuracion, nuevo_subestado } = this.state
        const loading = 'loadingConfiguracionNotificaciones'
        configuracion.idsubestado = nuevo_subestado._id
        this.setState({ [loading]: true })
        return fetch(`${data.urlapi}/estadoscarga/notificacion-subestado`, {
            method: 'PUT',
            body: JSON.stringify(configuracion),
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(pros => pros.json())
            .then(async pros => {
                if (!pros) {
                    toast.error('Hubo un error de servidor', this.state.toaststyle)
                    return this.setState({ [loading]: false })
                } else if (pros.errorMessage) {
                    toast.error(pros.errorMessage, this.state.toaststyle)
                    return this.setState({ [loading]: false })
                }
                toast.success(`Operación realizada exitosamente`, this.state.toaststyle)
                return this.setState({ [loading]: false })
            })
            .catch(async error => {
                console.log(error)
                this.setState({ [loading]: false })
                return toast.error("No pudimos consultar la información, intente de nuevo recargando la página", this.state.toaststyle)
            })
    }

    mostrarNotificacionesConfig() {
        const { loadingConfiguracionNotificaciones, loadingPlantillasWhatsapp, configuracion, plantillas_ws } = this.state
        if (loadingConfiguracionNotificaciones === true) return <CircularProgress />

        return <Grid item md={12} sx={12}>
            <Card className='shadow-sm rounded p-3 mb-3' sx={{ mb:5 }} >
                
                        <Card className='p-0 border-0 h-100' style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}>
                            <CardContent>
                            <Typography variant="h5" className='text-white'><BsWhatsapp /><b> Whatsapp</b></Typography>
                                <Typography style={{ fontWeight: 700 }}>Selecciona uno de los siguientes mensajes aprobados por whatsapp</Typography>
                                <FormControl fullWidth className='mb-3'>
                                    <InputLabel id='demo-simple-select-label'>Mensaje</InputLabel>
                                    <Select
                                    labelId='demo-simple-select-label'
                                    label='Mensaje'
                                    name="whatsapp_message"
                                    defaultValue={configuracion.whatsapp_message}
                                    onChange={this.handleChangeConfig}>
                                    {
                                        plantillas_ws.map(ws => {
                                            return <option value={ws._id}>{ws.mensaje}</option>
                                        })
                                    }
                                    <MenuItem value=''>Seleccione</MenuItem>
                                    <MenuItem value='web'>Web</MenuItem>
                                    <MenuItem value='movil'>Móvil</MenuItem>
                                    </Select>
                                </FormControl>
                                <Button className='btn btn-secondary shadow-sm w-100' onClick={() => this.guardarCambiosConfiguracion()}><b>GUARDAR CAMBIOS</b></Button>
                                </CardContent>
                            </Card>
            </Card>

            {/* <Card>
                <CardContent>
                <Typography variant='h5'><i className="far fa-envelope"></i> Configuración de notificaciones</Typography>
                <Divider />

                <Typography variant='h5'>Asunto</Typography>
                {this.opciones_plantillas('subject')}
                <TextField placeholder='Escribe el asunto de tu email de notificación' className='form-control mb-3 mt-4' name="subject" value={configuracion.subject} onChange={this.handleChangeConfig} />

                <Typography variant='h5'>Mensaje</Typography>
                {this.opciones_plantillas('message')}
                <TextField placeholder='Escribe el contenido del mensaje principal' className='form-control mb-3 mt-4' name="message" value={configuracion.message} onChange={this.handleChangeConfig} />

                <Button className='btn btn-success' onClick={() => this.guardarCambiosConfiguracion()}>GUARDAR CAMBIOS</Button>
                </CardContent>
            </Card> */}

        </Grid>
    }

    crearAccion(tipo_accion, idsubestado) {
        const { acciones_subestado_actual } = this.state
        const loading = 'loadingAcciones'
        this.setState({ [loading]: true })
        return fetch(`${data.urlapi}/estadoscarga/crear-accion`, {
            method: 'POST',
            body: JSON.stringify({ tipo_accion, idsubestado }),
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(pros => pros.json())
            .then(async pros => {
                console.log(pros)
                if (!pros) {
                    toast.error('Hubo un error de servidor', this.state.toaststyle)
                    return this.setState({ [loading]: false })
                } else if (pros.errorMessage) {
                    toast.error(pros.errorMessage, this.state.toaststyle)
                    return this.setState({ [loading]: false })
                }
                toast.success(`Operación realizada exitosamente`, this.state.toaststyle)
                if (pros._id) acciones_subestado_actual.push(pros)
                return this.setState({ [loading]: false, acciones_subestado_actual })
            })
            .catch(async error => {
                console.log(error)
                this.setState({ [loading]: false })
                return toast.error("No pudimos consultar la información, intente de nuevo recargando la página", this.state.toaststyle)
            })
    }

    handleChange = (panel) => (event, isExpanded) => {
        this.setState({ expanded: isExpanded ? panel : false });
      };
    

    tablaEstados(estados, subestados) {
        const { eliminando, expanded } = this.state
        if (estados.length < 1) return <div>
            <Typography variant="h5" >No hay estados de carga asociados</Typography>
        </div>

        return <div>
            <Typography variant='h4'>{estados.length} Estados de carga encontrados </Typography>
                {estados.map((estado, iestado) => {

                    const subest = subestados.filter(sub => sub.idparent === estado._id)
                    const string_accordion = `acc-${iestado}`
                    return <Accordion expanded={expanded === string_accordion } onChange={this.handleChange(string_accordion)}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            >
                            <Typography sx={{ width: '33%', flexShrink: 0 }}>
                                <Typography variant="h6" style={{ textTransform: "uppercase" }}>{estado.titulo} · <b>{estado.codigo_estado}</b>
                                    <i style={{ color: estado.color }} className="fas fa-circle ml-3"></i>
                                    <ButtonGroup>
                                        <Button size="sm" variant="outlined" onClick={() => this.editarEstado(estado)}>EDITAR</Button>
                                        <LoadingButton loading={eliminando} variant="outlined" size="sm" onClick={() => this.solicitarEliminar(estado._id)}>ELIMINAR</LoadingButton>
                                    </ButtonGroup>
                                </Typography>
                            </Typography>
                            <Typography sx={{ color: 'text.secondary' }}>{this.mostrarTiposServicioConcatenados(estado.tipos_servicio)}</Typography>
                            </AccordionSummary>
                            <AccordionDetails style={{ backgroundColor: "#f3f3f3" }}>
                            <Button size="sm" variant="text" onClick={() => this.nuevoSubEstado(estado._id)} startIcon={<FiPlus />} >CREAR SUBESTADO</Button>
                            <Divider sx={{ mt:1, mb:2 }} />
                                {
                                    subest.length > 0 ? subest.map((subestado, isub) => {
                                        return <div key={`subestado-${subestado._id}`}>
                                            <Typography variant="h6" style={{ textTransform: "uppercase" }} >{subestado.titulo} · <b>{subestado.codigo_estado}</b> <i style={{ color: subestado.color }} className="fas fa-circle"></i></Typography>
                                            <ButtonGroup>
                                                <Button size="sm" variant="outlined" onClick={() => this.editarSubEstado(subestado)}>EDITAR</Button>
                                                <Button size="sm" variant="outlined" onClick={() => this.solicitarEliminarSubEstado(subestado._id)}>ELIMINAR</Button>
                                            </ButtonGroup>
                                            {(isub + 1) === subest.length ? false : <Divider sx={{ mt:2, mb:2 }} />}
                                        </div>
                                    }) : <Typography variant="h6">No hay sub estados</Typography>
                                }
                            </AccordionDetails>
                    </Accordion>
                })}
        </div>

    }

    seleccionarEmpresa(empresa ) {
        this.getEstados(empresa.rut)
        this.getConfiguracion('servicios', empresa.rut, 'tipos_servicio')
        return this.setState({ empresa })
    }

    mostrarEstados() {

        const { estados, subestados, empresa, filtro_tipo_servicio, tipos_servicio, loadingEstados } = this.state

        if (loadingEstados === true) return <PantallaCargando />

        const estados_mostrar = filtro_tipo_servicio ? estados.filter(e => {
            if (e.tipos_servicio) {
                if (Array.isArray(e.tipos_servicio) !== false) {
                    if (e.tipos_servicio.length > 0) {
                        return e.tipos_servicio.includes(filtro_tipo_servicio)
                    }
                }
            }
            return false
        }) : estados

        let condicion_busqueda = { propietario: "admin", tipo: "servicios" }
        if(empresa) if(empresa.rut) condicion_busqueda.propietario = empresa.rut

        return <Grid container spacing={2}>
            <Grid item md={4}>
                <ModalEmpresas showSeleccionado={true} titulo="SELECCIONAR EMPRESA" seleccionarEmpresa={(compania) => this.seleccionarEmpresa(compania)} />
                {
                    empresa ? <div>
                    <Card sx={{ p:2, mt: 2 }}>
                    <Typography mb={0}>Empresa seleccionada</Typography>
                    <Typography variant='h4' mb={0}>{empresa.razon_social}</Typography>
                    <Button onClick={() => {
                        this.getEstados()
                        this.getConfiguracion('servicios', 'admin', 'tipos_servicio')
                        return this.setState({ empresa: false })
                    }}>REMOVER</Button>
                    </Card>
                    </div> : false
                }
                
            </Grid> 
            <Grid item md={4}>
            <Button size="sm" variant='outlined' style={{ width: "100%" }} onClick={() => this.setState({ tipovisualizacion: 'nuevoestado', nuevo_estado: {} })} startIcon={<FiPlus />}>CREAR NUEVO</Button>
            </Grid> 
            <Grid item md={12}>
            <SelectorGeneral key_label="title" key_value="_id" otherProps={{ label: "Tipo de servicio" }} strict={true} hideLabel={true} module="categorias" condicion_default={condicion_busqueda} onChange={data => console.log('id_categoria', data )} />
                <Divider sx={{ mt: 1, mb: 1}} />
                {this.tablaEstados(estados_mostrar, subestados)}
            </Grid> 

        </Grid>
    }

    mostrarVista() {
        const { tipovisualizacion, owner } = this.state
        if (tipovisualizacion === 'estados') return this.mostrarEstados()
        if (tipovisualizacion === 'nuevoestado') return this.formularioCreacion()
        if (tipovisualizacion === 'nuevosubestado') return this.formularioCreacionSubestado()
        // if (tipovisualizacion === 'flujos') return <FlujosEstadosCarga owner={owner} />
    }

    render() {
        return <Structure component={this.mostrarVista()}  />
    }
}

const mapStateToProps = (state) => {
    return {
        miusuario: state.miusuario,
        pais: state.pais
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        cerrarSesion: () => dispatch(cerrarSesion())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EstadosCarga);